import { h } from 'preact'
import CategoryBox from '@ui/CategoryBox/CategoryBox'

function SubCategories({ categories }) {
	return (
		<section className="subCategories">
			{categories.map(category => (
				<CategoryBox
					key={category.seName ?? category.url}
					category={category}
					showDescription={false}
				/>
			))}
		</section>
	)
}

export default SubCategories
